import { put, select } from 'redux-saga/effects'

import { getFlyerGibsPage } from '../../actions/api'
import { selectFlyerId } from '../../selectors/campaign'

function* onProductsFeedPageClick(action) {
  const { params: { page } } = action.payload
  const flyerId = yield select(selectFlyerId)
  yield put(getFlyerGibsPage(flyerId, page))
}

export default onProductsFeedPageClick
